import React, { useRef } from "react";
import Barcode from "react-jsbarcode";
import ReactToPrint from "react-to-print";
import { Button } from "antd";

const BarcodePrinter = ({ details, variation }) => {
  const componentRef = useRef();

  const barcodeLabel = () => {
    return (
      <div
        className="barcode-label"
        style={{
          width: "1.5in",
          height: "1in",
          padding: "2px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          pageBreakAfter: "always",
          border: "1px solid #e0e0e0",
          boxSizing: "border-box",
          overflow: "hidden"
        }}
      >
        <div style={{ 
          fontSize: "8px", 
          fontWeight: "700", 
          textAlign: "center",
          lineHeight: "1",
          marginBottom: "2px",
          marginTop: "10px",
        }}>
          STATION
        </div>
        
        <div style={{ 
          fontSize: "8px", 
          fontWeight: "500", 
          textAlign: "center",
          lineHeight: "1.1",
          marginBottom: "1px",
          overflow: "hidden"
        }}>
          {variation.category} {variation.title}          
        </div>
        
        <div style={{ 
          fontSize: "8px", 
          fontWeight: "500", 
          textAlign: "center",
          marginBottom: "1px",
          overflow: "hidden"
        }}>
          ({details.brand_name}) | {variation.Attribute_details}
        </div>
        
        <div style={{ marginBottom: "0px" }}>
          <Barcode 
            options={{ 
              height: 20,
              width: 1.3,
              fontSize: 8,
              margin: 0,
              displayValue: true
            }} 
            value={variation.barcode} 
          />
        </div>

        <div style={{ 
          fontSize: "8px", 
          fontWeight: "500", 
          textAlign: "center",
          marginBottom: "1px"
        }}>
          {variation.batch_no}
        </div>
      </div>
    );
  };

  return (
    <>
      <style>
        {`
          @media print {
            @page {
              size: 1.5in 1in;
              margin: 0;
            }
            
            body {
              margin: 0;
              padding: 0;
            }
            
            .barcode-label {
              page-break-after: always;
              border: none !important;
            }
            
            .no-print {
              display: none !important;
            }
            
            .print-container {
              margin: 0;
              padding: 0;
            }
          }
          
          @media screen {
            .barcode-wrapper {
              display: inline-block;
              margin: 10px;
              vertical-align: top;
            }
            
            .barcode-item {
              text-align: center;
            }
            
            .barcode-item .barcode-label {
              margin-bottom: 8px;
            }
          }
        `}
      </style>

      <div className="barcode-wrapper">
        <div className="barcode-item">
          <div ref={componentRef}>
            {barcodeLabel()}
          </div>
          <ReactToPrint
            trigger={() => (
              <Button 
                type="primary" 
                size="small"
                style={{ marginTop: "5px" }}
              >
                Print Barcode
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle={`
              @page {
                size: 1.5in 1in;
                margin: 0;
              }
            `}
          />
        </div>
      </div>
    </>
  );
};

export default BarcodePrinter;